export const canParseUrl = (url: string, base?: string) => {
  try {
    new URL(url, base);

    return true;
  } catch (e) {
    return false;
  }
};
